import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
/**
 * Base styles for the PlanSettings component
 */ export const usePlanSettingsStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: tokens.colorNeutralBackground1
    },
    content: {
        flex: "1 1 auto",
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacingVerticalXL
    },
    titleSection: {
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacingVerticalS
    },
    planTitleHeader: {
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
        marginBottom: tokens.spacingVerticalXS
    },
    backgroundSection: {
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacingVerticalM
    },
    backgroundPicker: {
        // Fluid responsive grid: each tile gets at least 180px and stretches to fill the row.
        // The container's available width determines the column count automatically:
        //   wide dialog body (~600px)  -> 3 columns
        //   plan settings side panel    -> 2 columns
        //   very narrow viewport        -> 1 column
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
        gap: tokens.spacingHorizontalM
    },
    backgroundOption: {
        position: "relative",
        cursor: "pointer",
        borderRadius: tokens.borderRadiusMedium,
        border: `2px solid ${tokens.colorNeutralStroke2}`,
        overflow: "hidden",
        transition: "border-color 0.2s ease"
    },
    backgroundOptionReadonly: {
        position: "relative",
        cursor: "default",
        borderRadius: tokens.borderRadiusMedium,
        border: `2px solid ${tokens.colorNeutralStroke2}`,
        overflow: "hidden",
        transition: "border-color 0.2s ease"
    },
    selected: {
        border: `4px solid ${tokens.colorBrandStroke1}`
    },
    backgroundThumbnail: {
        // Responsive thumbnail: fills the grid cell width and tracks the original 240x136
        // aspect ratio so the SVG board-layout overlay stays in proportion at any tile size.
        width: "100%",
        height: "auto",
        aspectRatio: "240 / 136",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusSmall,
        overflow: "hidden",
        position: "relative"
    },
    backgroundImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover"
    },
    backgroundOverlay: {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        opacity: 0.89
    },
    backgroundOverlayDefault: {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        opacity: 1
    },
    noBackgroundIndicator: {
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground3,
        textAlign: "center",
        padding: tokens.spacingHorizontalS
    },
    sectionHeader: {
        fontSize: tokens.fontSizeBase300,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
        marginBottom: tokens.spacingVerticalXS
    },
    comingSoon: {
        fontSize: tokens.fontSizeBase200,
        color: tokens.colorNeutralForeground3,
        fontStyle: "italic",
        padding: tokens.spacingVerticalM,
        textAlign: "center",
        backgroundColor: tokens.colorNeutralBackground2,
        borderRadius: tokens.borderRadiusMedium,
        border: `1px dashed ${tokens.colorNeutralStroke2}`
    },
    footer: {
        marginTop: "auto",
        paddingTop: tokens.spacingVerticalL,
        paddingBottom: tokens.spacingVerticalM,
        display: "flex",
        justifyContent: "flex-start"
    },
    deleteButton: {
        borderRadius: tokens.borderRadiusXLarge,
        minWidth: "auto",
        fontWeight: tokens.fontWeightRegular
    },
    loadingState: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: tokens.spacingHorizontalS,
        padding: tokens.spacingVerticalL
    },
    loadingText: {
        color: tokens.colorNeutralForeground2,
        fontSize: tokens.fontSizeBase200
    },
    emptyState: {
        display: "flex",
        flexDirection: "column"
    },
    errorMessage: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: tokens.spacingVerticalM
    },
    errorText: {
        color: tokens.colorNeutralForeground2,
        fontSize: tokens.fontSizeBase200,
        textAlign: "center"
    },
    aiDesignerAttribution: {
        display: "flex",
        justifyContent: "flex-end",
        fontSize: tokens.fontSizeBase200,
        a: {
            color: tokens.colorBrandForeground1,
            fontSize: tokens.fontSizeBase200,
            textDecoration: "none"
        }
    }
});
/**
 * Re-export mergeClasses utility for combining FluentUI v9 styles
 */ export { mergeClasses };
